import {VideoView} from './VideoView';

export {Video} from './Video';

export const videoRegistrations = {
    'Video': VideoView,
};